import BoxNotification from "./Component/BoxNotification";
import { List } from "@mui/material";

export function ListNotification({
  notifications,
  onNotificationClick,
  isShowAll,
}) {
  return (
    <List sx={{ minHeight: "calc(100vh - 185px)" }}>
      {notifications?.map((notification, index) => (
        <BoxNotification
          onNotificationClick={onNotificationClick}
          notification={notification}
          key={index}
          isShowAll={isShowAll}
        />
      ))}
    </List>
  );
}

export default ListNotification;
